export default "__VITE_ASSET__caa00c61__"